const Constants = {
  CELIA: "Celia Mijares",
  REACHEL: "Rachel L. Francis"
};

export default Constants;
